import { render } from "./EntraIdConfig.vue?vue&type=template&id=6b0aa0ef"
import script from "./EntraIdConfig.vue?vue&type=script&lang=js"
export * from "./EntraIdConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__